import { render, staticRenderFns } from "./sendDoc.vue?vue&type=template&id=c3d5fb58&"
import script from "./sendDoc.vue?vue&type=script&lang=js&"
export * from "./sendDoc.vue?vue&type=script&lang=js&"
import style0 from "./sendDoc.vue?vue&type=style&index=0&id=c3d5fb58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports